import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {
  Card,
  CardContent,
  IconButton,
  Typography,
  Box,
} from '@material-ui/core';
import {Trash2, Truck, MapPin, Calendar, User, Hash} from 'react-feather';

const useStyles = makeStyles(theme => ({
  card: {
    borderRadius: 5,
    boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
    overflow: 'hidden',
    maxWidth: 255,
    maxHeight: 190,
  },
  media: {
    height: 80,
    position: 'relative',
    margin: '8px 8px 0px 8px',
    borderRadius: 5,
    backgroundColor: '#f0f0f0',
  },
  actionIcons: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
    display: 'flex',
    gap: theme.spacing(1),
  },
  iconButton: {
    backgroundColor: '#F2F9FF',
    width: 28,
    height: 28,
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: '#E0F0FF',
      '& svg': {
        stroke: '#36A6FF',
      },
    },
  },
  content: {
    padding: 10,
  },
  row: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 8,
  },
  collected: {
    fontWeight: 500,
  },
  icon: {
    color: theme.palette.primary.main,
    fontSize: '1.2rem',
    flexShrink: 0,
  },
  pairItems: {
    display: 'flex',
    alignItems: 'center',
    minWidth: '45%',
    gap: 4,
    flex: 1,
    '& p': {
      display: '-webkit-box',
      '-webkit-line-clamp': 1,
      '-webkit-box-orient': 'vertical',
      overflow: 'hidden',
    },
  },
  leftColumn: {
    marginRight: 35,
  },
}));

interface CommonCardProps {
  image: string;
  id: string;
  code?: string;
  name: string;
  location: string;
  date: string;
  status?: string;
  onDelete?: (event: any) => void;
}

const CorrectItemCard: React.FC<CommonCardProps> = ({
  image,
  id,
  code,
  name,
  location,
  date,
  status,
  onDelete,
}) => {
  const classes = useStyles();

  return (
    <Card className={classes.card}>
      <Box
        className={classes.media}
        style={{
          backgroundImage: `url(${image})`,
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'center',
        }}
      >
        <Box className={classes.actionIcons}>
          <IconButton
            size="small"
            onClick={onDelete}
            className={classes.iconButton}
          >
            <Trash2 size={16} />
          </IconButton>
        </Box>
      </Box>
      <CardContent className={classes.content}>
        <Box className={classes.row}>
          <Box className={`${classes.pairItems} ${classes.leftColumn}`}>
            <Hash className={classes.icon} size={16} />
            <Typography variant="body2">{code ?? '-'}</Typography>
          </Box>

          <Box className={classes.pairItems}>
            <Truck className={classes.icon} size={16} />
            <Typography variant="body2" className={classes.collected}>
              {status ?? '-'}
            </Typography>
          </Box>
        </Box>

        <Box className={classes.row}>
          <Box className={`${classes.pairItems} ${classes.leftColumn}`}>
            <User className={classes.icon} size={16} />
            <Typography variant="body2">{name}</Typography>
          </Box>

          <Box className={classes.pairItems}>
            <MapPin className={classes.icon} size={16} />
            <Typography variant="body2">{location}</Typography>
          </Box>
        </Box>

        <Box className={classes.row}>
          <Box className={`${classes.pairItems} ${classes.leftColumn}`}>
            <Calendar className={classes.icon} size={16} />
            <Typography variant="body2">{date}</Typography>
          </Box>
        </Box>
      </CardContent>
    </Card>
  );
};

export default CorrectItemCard;
